import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Bell, BellRinging } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

// Follow a person / institution / faculty group and get notified of activity.
export function FollowButton({ targetType, targetId, size = "sm" }) {
  const { user } = useAuth();
  const [state, setState] = useState({ following: false, followers: 0 });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/follow/${targetType}/${targetId}/status`).then((r) => setState(r.data)).catch(() => {});
  }, [targetType, targetId]);

  const toggle = async () => {
    if (!user) { toast.error("Sign in to follow"); return; }
    setBusy(true);
    try {
      const { data } = state.following
        ? await api.delete(`/follow/${targetType}/${targetId}`)
        : await api.post(`/follow/${targetType}/${targetId}`);
      setState(data);
      toast.success(data.following ? "Following — you'll get updates" : "Unfollowed");
    } catch { toast.error("Could not update"); }
    finally { setBusy(false); }
  };

  return (
    <Button variant={state.following ? "secondary" : "outline"} size={size} disabled={busy}
      onClick={toggle} className="rounded-full gap-1.5" data-testid={`follow-${targetType}-btn`}>
      {state.following ? <BellRinging size={14} weight="fill" /> : <Bell size={14} />}
      {state.following ? "Following" : "Follow"}
      {state.followers > 0 && <span className="text-xs opacity-70">{state.followers}</span>}
    </Button>
  );
}

export default FollowButton;
